import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PaginatedEnsueCollection } from "../../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";
import { ManageFootballHostedCompetition } from "../../../../../../commons/models/football/admin/manage-football-hosted-competition";

export interface IHostedCompetitionListOptions {
  teamId: number;
  urlParams?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

export interface IManageCompetitionListState {
  hostedCompetitionList: PaginatedEnsueCollection<ManageFootballHostedCompetition>;
  hostedCompetitionListStatus: StatusEnum;
}

const initialState: IManageCompetitionListState = {
  hostedCompetitionList: new PaginatedEnsueCollection<ManageFootballHostedCompetition>(),
  hostedCompetitionListStatus: StatusEnum.Idle,
};

export const fetchManageHostedCompetitionList = createAsyncThunk(
  "manage/hostedCompetitionList",
  async (options: IHostedCompetitionListOptions, thunkAPI) => {
    try {
      const competitionList = await manageFootballTeamService.getHostedCompetitions(options.teamId, options.urlParams);
      return competitionList as PaginatedEnsueCollection<ManageFootballHostedCompetition>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageHostedCompetitionListSlice = createSlice({
  name: "footballManageHostedCompetitionList",
  initialState: initialState,
  reducers: {
    cleanUpManageHostedCompetitionList(state) {
      state.hostedCompetitionList = new PaginatedEnsueCollection<ManageFootballHostedCompetition>();
      state.hostedCompetitionListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageHostedCompetitionList.pending, (state) => {
        state.hostedCompetitionListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageHostedCompetitionList.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<ManageFootballHostedCompetition>>) => {
          state.hostedCompetitionListStatus = StatusEnum.Succeeded;
          state.hostedCompetitionList = action.payload;
        }
      )
      .addCase(fetchManageHostedCompetitionList.rejected, (state) => {
        state.hostedCompetitionListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManageHostedCompetitionList } = footballManageHostedCompetitionListSlice.actions;
export default footballManageHostedCompetitionListSlice.reducer;
